import { RouterProvider } from "react-router-dom";
import { useSupabase } from "./contexts/SupabaseContext";
import router from "./routes";
import { GenericSelect, Spinner } from "@asez/component-library";

const App = () => {
  const { loading } = useSupabase();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[100vh]">
        <Spinner size={32} />
      </div>
    );
  }

  return <RouterProvider router={router} />;
};

export default App;
